import { memo, useEffect, useRef } from "react";
import { noticeError } from "../../../utils/newrelic/requests";

type Props = {
  src: string;
  id: string;
};

const generateWrapperId = ({ id, src }: Props) => {
  // Use the src prop to generate an id attribute for the wrapping element
  const regex = /\/?([\w-/]*)/;
  let wrapperId = "";
  if (src) {
    const assemblySource = src.match(regex) || [];
    wrapperId = `assembly-${assemblySource[1]}-${id}`
      .replace(/\//g, "-") // change / to -
      .replace(/-+/g, "-") // remove duplicate -
      .toLowerCase();
  }

  return wrapperId;
};

const SimpleESIInclude = ({ id, src }: Props) => {
  const isMounting = useRef(true);
  const wrapperId = generateWrapperId({ src, id });

  useEffect(() => {
    if (!isMounting.current) {
      noticeError(`ESI re-rendered unexpectedly. ${id}`);
    } else {
      isMounting.current = false;
    }
  });

  useEffect(() => {
    if (
      document.querySelector(`#${id}`)?.nodeName?.toLowerCase() ===
        "esi:include" &&
      window.location.origin.includes("johnlewis.com")
    ) {
      noticeError(`esi:include tag rendered on the client "${id}"`);
    }
  }, []);

  return (
    <div
      id={wrapperId}
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{
        __html: `<esi:include id="${id}" ${src ? ` src="${src}"` : ""} />`,
      }}
    />
  );
};

export const ESIInclude = memo(SimpleESIInclude);
